<p-dialog
  #selectDialog
  modal="true"
  [(visible)]="showModal"
  [closable]="true"
  styleClass="atlas-dialog-m"
  [focusOnShow]="false"
  [contentStyle]="{ 'max-height': '75vh' }"
>
  <ng-template pTemplate="header">
    <h4 class="modal-title text-center">
      {{ 'events.registration.management.selector.title' | translate | titlecase }}
      <wl-busy *ngIf="isSearching" [show]="isSearching"></wl-busy>
    </h4>
    <div class="container-fluid form-horizontal">
      <div class="row">
        <div class="col-sm-9">
          <div *ngIf="selectedAction == 7">
            <div class="form-group">
              <label class="col-sm-4 control-label"
                >{{ 'events.registration.management.selector.select-payment-type' | translate | titlecase }}:</label
              >
              <div class="col-sm-8">
                <wl-payment-type-selector
                  [(ngModel)]="paymentType.PaymentTypeId"
                  (onPaymentTypeChanged)="onPaymentTypeChange($event)"
                ></wl-payment-type-selector>
              </div>
            </div>

            <div class="form-group">
              <label class="col-sm-4 control-label"
                >{{ 'events.registration.management.selector.select-payment-source' | translate | titlecase }}:</label
              >
              <div class="col-sm-8">
                <select class="form-control" [(ngModel)]="selectedPaymentSource" (ngModelChange)="onPaymentSourceChange($event)">
                  <option *ngFor="let paymentSource of paymentSources" [value]="paymentSource.PaymentSource">
                    {{ paymentSource.PaymentSource }}
                  </option>
                </select>
              </div>
            </div>

            <div class="form-group">
              <label class="col-sm-4 control-label"
                >{{ 'events.registration.management.selector.payment-date' | translate | titlecase }}:</label
              >
              <div class="col-sm-8">
                <wl-date-selector name="paymentDate" [(ngModel)]="paymentDate"></wl-date-selector>
              </div>
            </div>

            <div class="form-group">
              <label class="col-sm-4 control-label"
                >{{ 'events.registration.management.selector.apply-date' | translate | titlecase }}:</label
              >
              <div class="col-sm-8">
                <wl-date-selector name="applyDate" [(ngModel)]="applyDate"></wl-date-selector>
              </div>
            </div>
          </div>
        </div>
        <div class="col-sm-3">
          <wl-busy *ngIf="_executing" [show]="_executing"></wl-busy>
          <button
            pButton
            type="button"
            class="atlas-btn atlas-btn-primary"
            [icon]="_executing ? '' : 'pi pi-bolt'"
            [label]="(_executing ? 'common.executing' : 'common.execute') | translate | titlecase"
            (click)="execute()"
            [disabled]="_executing"
          ></button>
          <cancel-button [label]="'common.cancel' | translate | titlecase" (onClick)="cancel()"> </cancel-button>
        </div>
      </div>

      <p *ngIf="isSearching == false">
        <strong>
          <input type="checkbox" [(ngModel)]="selectAll" (ngModelChange)="toggleSelectAll()" />
          <label *ngIf="!selectAll">
            {{ 'common.select-all' | translate | titlecase }}
          </label>
          <label *ngIf="selectAll">
            {{ 'common.deselect-all' | translate | titlecase }}
          </label>
        </strong>
      </p>
    </div>
  </ng-template>
  <p class="alert alert-danger" *ngIf="error">{{ error }}</p>

  <div class="row" *ngIf="selectedAction == 5">
    <div class="col-sm-offset-3 col-sm-6">
      <wl-affcode-mass-add #massAddAffCode [showButtons]="false"></wl-affcode-mass-add>
    </div>
  </div>

  <p-table [showGridlines]="true"
    *ngIf="isSearching == false"
    #eventPaymentMethodsDataGrid
    [rows]="99999"
    [value]="registrationSearchResult.Result"
    [paginator]="false"
    [totalRecords]="registrationSearchResult.TotalCount"
  >
    <ng-template pTemplate="sorticon" field="col.field" let-sortOrder>
      <SortAltIcon *ngIf="sortOrder === 0">
        <span><i class="p-sortable-column-icon pi pi-fw pi-sort-alt" aria-hidden="true"></i></span>
      </SortAltIcon>
      <SortAmountUpAltIcon *ngIf="sortOrder === 1" [styleClass]="'p-sortable-column-icon'">
        <span><i class="p-sortable-column-icon pi pi-fw pi-sort-amount-up-alt" aria-hidden="true"></i></span>
      </SortAmountUpAltIcon>
      <SortAmountDownIcon *ngIf="sortOrder === -1" [styleClass]="'p-sortable-column-icon'">
        <span><i class="p-sortable-column-icon pi pi-fw pi-sort-amount-down" aria-hidden="true"></i></span>
      </SortAmountDownIcon>
    </ng-template>
    <ng-template pTemplate="header">
      <tr>
        <th class="text-center" style="width: 40px"></th>
        <th class="text-center" style="width: 150px">
          {{ 'common.personal-information.profile-id' | translate | titlecase }}
        </th>
        <th>{{ 'common.personal-information.org-name' | translate | titlecase }}</th>
        <th>{{ 'common.personal-information.name' | translate | titlecase }}</th>
        <th>{{ 'common.personal-information.email' | translate | titlecase }}</th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-dataItem>
      <tr>
        <td class="text-center"><input type="checkbox" [(ngModel)]="dataItem.Selected" /></td>
        <td>{{ dataItem.ProfileID }}</td>
        <td>{{ dataItem.OrgName }}</td>
        <td>{{ dataItem.FirstName }}&nbsp;{{ dataItem.LastName }}</td>
        <td>{{ dataItem.Email }}</td>
      </tr>
    </ng-template>
  </p-table>
  <p-progressSpinner *ngIf="isSearching"></p-progressSpinner>
</p-dialog>
